import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_3 = { class: "tp-template-group" }
const _hoisted_4 = { colspan: "4" }
const _hoisted_5 = { class: "d-flex align-center ga-1" }
const _hoisted_6 = { class: "text-caption" }
const _hoisted_7 = { class: "text-right tp-template-actions" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "d-flex align-center" }
const _hoisted_10 = { class: "d-flex align-center mt-1 tp-template-header" }
const _hoisted_11 = {
  key: 0,
  class: "d-flex align-center ga-1"
}
const _hoisted_12 = { class: "text-subtitle-1" }
const _hoisted_13 = {
  key: 1,
  class: "d-flex align-center ga-1"
}
const _hoisted_14 = { class: "text-caption text-grey-darken-1" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_17 = {
  key: 2,
  class: "ml-2"
}
const _hoisted_18 = {
  key: 0,
  class: "text-caption text-warning mr-3 tp-template-dirty"
}
const _hoisted_19 = {
  key: 0,
  class: "text-caption"
}
const _hoisted_20 = { class: "mt-3" }
const _hoisted_21 = { class: "mt-4" }
const _hoisted_22 = {
  key: 1,
  class: "text-caption text-grey-darken-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_teaching_plan_layout_builder = _resolveComponent("teaching-plan-layout-builder")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.editingTemplateId)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _cache[12] || (_cache[12] = _createElementVNode("div", null, [
              _createElementVNode("div", { class: "text-subtitle-1" }, "帳票レイアウト"),
              _createElementVNode("div", { class: "text-caption text-grey-darken-1" }, " 同じ帳票種別のレイアウトを名前付きで複数持てます。帳票作成時にどれを使うか選びます。 ")
            ], -1)),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "flat",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCreateDialog(null)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { start: "" }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("mdi-plus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[11] || (_cache[11] = _createTextVNode(" レイアウトを作成 ", -1))
              ]),
              _: 1
            })
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "primary"
                })
              ]))
            : (_openBlock(), _createBlock(_component_v_table, {
                key: 1,
                density: "compact",
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "レイアウト名"),
                      _createElementVNode("th", { style: {"width":"190px"} }, "公開状態"),
                      _createElementVNode("th", { style: {"width":"170px"} }, "最終公開"),
                      _createElementVNode("th", { style: {"width":"230px"} })
                    ])
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planTypeOrder, (planType) => {
                    return (_openBlock(), _createElementBlock("tbody", { key: planType }, [
                      _createElementVNode("tr", _hoisted_3, [
                        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.planTypeLabels[planType]), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templatesOf(planType), (template) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: template.templateId
                        }, [
                          _createElementVNode("td", null, _toDisplayString(template.name), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_v_chip, {
                                color: template.version === null ? 'grey' : 'success',
                                size: "small",
                                variant: "flat"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(template.version === null ? "未公開" : `第${template.version}版`), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"]),
                              (template.hasDraft)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    size: "small",
                                    variant: "outlined"
                                  }, {
                                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                      _createTextVNode(" 下書きあり ", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.formatDateTime(template.publishedAt) || "—"), 1),
                          _createElementVNode("td", _hoisted_7, [
                            _createVNode(_component_v_btn, {
                              size: "small",
                              variant: "text",
                              color: "primary",
                              onClick: ($event: any) => (_ctx.edit(template))
                            }, {
                              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                _createTextVNode(" 編集 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              size: "small",
                              variant: "text",
                              onClick: ($event: any) => (_ctx.openCreateDialog(template))
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode(" 複製 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              size: "small",
                              variant: "text",
                              color: "error",
                              loading: _ctx.deletingTemplateId === template.templateId,
                              onClick: ($event: any) => (_ctx.remove(template))
                            }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode(" 削除 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["loading", "onClick"])
                          ])
                        ]))
                      }), 128)),
                      (_ctx.templatesOf(planType).length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[17] || (_cache[17] = [
                            _createElementVNode("td", {
                              colspan: "4",
                              class: "text-center text-grey py-3"
                            }, " レイアウトがありません。 ", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }))
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_btn, {
              variant: "text",
              size: "small",
              onClick: _ctx.closeEditor
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { start: "" }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode("mdi-chevron-left", -1)
                  ]))]),
                  _: 1
                }),
                _cache[20] || (_cache[20] = _createTextVNode(" レイアウト一覧へ ", -1))
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              (!_ctx.renaming)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.editingTemplate ? _ctx.editingTemplate.name : ""), 1),
                    _createVNode(_component_v_btn, {
                      size: "x-small",
                      variant: "text",
                      color: "primary",
                      loading: _ctx.savingName,
                      onClick: _ctx.startRename
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          start: "",
                          size: "14"
                        }, {
                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                            _createTextVNode("mdi-pencil-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[22] || (_cache[22] = _createTextVNode(" 名称を変更 ", -1))
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_v_text_field, {
                      ref: "nameInput",
                      modelValue: _ctx.renameInput,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.renameInput) = $event)),
                      label: "レイアウト名",
                      variant: "outlined",
                      density: "compact",
                      color: "primary",
                      "hide-details": "",
                      autofocus: "",
                      style: {"min-width":"280px"},
                      error: !_ctx.isValidName(_ctx.renameInput),
                      onKeydown: [
                        _withKeys(_ctx.commitRename, ["enter"]),
                        _withKeys(_ctx.cancelRename, ["esc"])
                      ]
                    }, null, 8, ["modelValue", "error", "onKeydown"]),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "flat",
                      color: "primary",
                      loading: _ctx.savingName,
                      disabled: !_ctx.isValidName(_ctx.renameInput),
                      onClick: _ctx.commitRename
                    }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode(" 名称を保存 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading", "disabled", "onClick"]),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "text",
                      disabled: _ctx.savingName,
                      onClick: _ctx.cancelRename
                    }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode(" 取消 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ])),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.editingTemplate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.planTypeLabels[_ctx.editingTemplate.planType]), 1))
                  : _createCommentVNode("", true),
                (_ctx.editingTemplate && _ctx.editingTemplate.version !== null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, " 公開中: 第" + _toDisplayString(_ctx.editingTemplate.version) + "版 ", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_17, "未公開"))
              ])
            ]),
            _createVNode(_component_v_spacer),
            (_ctx.isLayoutDirty)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                  _createVNode(_component_v_icon, { size: "14" }, {
                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                      _createTextVNode("mdi-circle-medium", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[26] || (_cache[26] = _createTextVNode(" 未保存の変更があります ", -1))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_btn, {
              class: "mr-2",
              variant: "outlined",
              color: "primary",
              loading: _ctx.savingDraft,
              disabled: _ctx.layoutErrors.length > 0,
              onClick: _ctx.saveDraft
            }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createTextVNode(" 下書きを保存 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"]),
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "flat",
              loading: _ctx.publishing,
              disabled: _ctx.layoutErrors.length > 0,
              onClick: _ctx.publish
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode(" 公開する ", -1)
              ]))]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"])
          ]),
          (_ctx.layoutErrors.length > 0)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                type: "warning",
                variant: "tonal",
                density: "compact",
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layoutErrors.slice(0, 5), (error) => {
                    return (_openBlock(), _createElementBlock("div", { key: error }, _toDisplayString(error), 1))
                  }), 128)),
                  (_ctx.layoutErrors.length > 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, " ほか" + _toDisplayString(_ctx.layoutErrors.length - 5) + "件 ", 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.editingTemplate && _ctx.editingTemplate.version === null)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 1,
                type: "info",
                variant: "tonal",
                density: "compact",
                class: "mt-3"
              }, {
                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                  _createTextVNode(" 公開するまで、このレイアウトで指導計画を作成することはできません。 ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            (_ctx.draftLayout)
              ? (_openBlock(), _createBlock(_component_teaching_plan_layout_builder, {
                  key: _ctx.editingTemplateId,
                  modelValue: _ctx.draftLayout,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.draftLayout) = $event)),
                  onValidityChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.layoutErrors = $event)),
                  onOpenPhrase: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('open-phrase', { templateId: _ctx.editingTemplateId, phraseKey: $event })))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "text-subtitle-2 mb-1" }, "転記ルール", -1)),
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "text-caption text-grey-darken-1 mb-2" }, " このレイアウトに上位計画から値を引き込む設定です。 ", -1)),
            (_ctx.canEditTransferRule)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  variant: "outlined",
                  color: "primary",
                  size: "small",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('open-transfer-rule', _ctx.editingTemplateId)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                        _createTextVNode("mdi-arrow-decision-outline", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[31] || (_cache[31] = _createTextVNode(" このレイアウトの転記ルールを編集 ", -1))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.transferRuleDisabledReason), 1))
          ])
        ], 64)),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.createDialog,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.createDialog) = $event)),
      "max-width": "560px",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.copyFrom ? "レイアウトを複製" : "レイアウトを作成"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.createInput.planType,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.createInput.planType) = $event)),
                  items: _ctx.createPlanTypeItems,
                  label: "帳票種別",
                  variant: "outlined",
                  density: "compact",
                  color: "primary",
                  class: "mb-3",
                  "hide-details": "",
                  disabled: _ctx.copyFrom !== null
                }, null, 8, ["modelValue", "items", "disabled"]),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.createInput.name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.createInput.name) = $event)),
                  label: "レイアウト名",
                  variant: "outlined",
                  density: "compact",
                  color: "primary",
                  counter: _ctx.templateNameMaxLength,
                  hint: _ctx.copyFrom ? `${_ctx.copyFrom.name} の公開版を複製します` : '標準レイアウトから作成します',
                  "persistent-hint": ""
                }, null, 8, ["modelValue", "counter", "hint"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  disabled: _ctx.creating,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.createDialog = false))
                }, {
                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                    _createTextVNode(" キャンセル ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  loading: _ctx.creating,
                  disabled: !_ctx.isValidName(_ctx.createInput.name),
                  onClick: _ctx.create
                }, {
                  default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                    _createTextVNode(" 作成 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}